import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../services/api.service';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../editorconfig';
import { environment } from '../../../environments/environment';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-idex-sqr',
  standalone: false,
  templateUrl: './idex-sqr.component.html',
  styleUrl: './idex-sqr.component.scss',
})
export class IdexSqrComponent implements OnInit, AfterViewInit, OnDestroy {
  @Output() stepCompleted = new EventEmitter<void>();
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean;
  @Input() stepDetails: any;
  @Input() schemeType: string;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  challengeForm: FormGroup;
  proposalForm: FormGroup;
  status: any;
  filteredItems: any[] = [];
  selectedItem: any;
  payload: any;
  @Output() generatePDFEmitter: EventEmitter<any> = new EventEmitter();
  items: any;
  @Input() id: any;
  PDSGenId: any;
  challengeID: any;
  currentUserCode: any;
  apiUrl = environment.APIUrl;
  needGenData: any;
  userID:any
  private subscriptions = new Subscription();
   categoryOptions = [
  { label: 'To Move', value: 'To Move' },
  { label: 'To Fight', value: 'To Fight' },
  { label: 'To Float', value: 'To Float' }
];
  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private api: ApiService
  ) {
     const role = sessionStorage.getItem('user_role_id');
    this.userID = role
  }

  ngOnInit(): void {
  this.challengeForm = this.fb.group({
      organisation: ['', Validators.required],
      category: ['', Validators.required],
      releaseDate: ['', Validators.required],
      approvedBy: [''],
      coordinatingAgency: ['', Validators.required],
      technologyDomain: ['', Validators.required],

      challengeTitle: ['', Validators.required],
      nodalOfficer: ['', Validators.required],
      problemStatement: ['', Validators.required],
      challengeBrief: ['', Validators.required],
      prototypeDevelopment: ['', Validators.required],
      requirement: ['', Validators.required],
      ipValue: [''],
      functionalAdvantages: ['', Validators.required],
      domestic: ['', Validators.required],
      substitution: ['', Validators.required],
      preliminaryScope: ['', Validators.required],
      competitiveSolution: ['', Validators.required],
      potentialMarket: ['', Validators.required],
      riskAssessment: ['', Validators.required],
      mpoQty: ['', Validators.required],
    });
    this.proposalForm = this.fb.group({
      technologyInsertion: [''],
      justificationText: [''],
      exportPotential: [''],
      stakeholderDiscussions: [''],
      objective: [''],
      existingSystem: [''],
      functionalRequirements: [''],
      contemporarySolutions: [''],
      miscellaneousInfo: [''],
      references: [''],
      keywords: [''],
      estimatedRequirement: [''],
      testingMethodology: [''],
      civilSpinOffs: [''],
      technologyReadinessLevel: [''],
      proposalExplanation: [''],
      qaAgency: [''],
      apsoConcurrence: [''],
      pqsr: [''],
      additionalInformation: [''],
      quantityRequired: [''],
    });

    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        proposal_name: proposalName,
      };
    });
    
    // Set status to 'received' by default so form appears without checkbox
    this.status = 'received';
    this.getUserData();
    
    this.getChallenge();
    this.currentUserCode = sessionStorage.getItem('user_role_code');
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.isEditable) {
        this.isEditorDisabled = false;
        this.challengeForm.enable();
        this.proposalForm.enable();
      } else {
        this.isEditorDisabled = true;
        this.challengeForm.disable();
        this.proposalForm.disable();
      }
      this.rebuildEditor();
    }, 3000);
  }
  editorReady = false;
  rebuildEditor() {
    this.editorReady = false; // destroy
    setTimeout(() => {
      this.init = this.getTinyInit(); // refresh config
      this.editorReady = true; // recreate editor
    }, 0);
  }
  getTinyInit(): EditorComponent['init'] {
    return {
      readonly: this.isEditorDisabled,
    };
  }
  goToNextStep() {
    this.stepCompleted.emit();
  }
  // toggleReceived() {
  //   this.status = this.status;
  //   if (this.status == 'received') {
  //     this.getUserData();
  //   }
  // }
  getUserData() {
    const sub = this.api
      .getAPI('/account/users/?user_role__code=PDIRECTORATE')
      .subscribe((res: any) => {
        this.items = res.data || [];
      });
    this.subscriptions.add(sub);
    this.getChallenge();
  }
  searchItems(event: any) {
    const query = event.query.toLowerCase();
    this.filteredItems = this.items.filter((item) =>
      item.first_name.toLowerCase().includes(query)
    );
  }
  generatePDF() {
    let payload;
    if (this.schemeType == 'tdf') {
      payload = {
        url: '/revenue/need/version-control/',
        data: [
          { key: 'Proposal Name', value: this.payload?.proposal_name },
          {
            key: 'Title of the Requirement',
            value: this.proposalForm.get('technologyInsertion')?.value,
          },
          {
            key: 'Description of major system/sub-system and usage',
            value: this.proposalForm.get('justificationText')?.value,
          },
          {
            key: 'Reason for pursuing under TDF scheme',
            value: this.proposalForm.get('exportPotential')?.value,
          },
          {
            key: 'Technology Area (Discipline, Sub-discipline)',
            value: this.proposalForm.get('stakeholderDiscussions')?.value,
          },
          {
            key: 'Objective (Product/System/Item)',
            value: this.proposalForm.get('objective')?.value,
          },
          {
            key: 'Existing System Description & Use',
            value: this.proposalForm.get('existingSystem')?.value,
          },
          {
            key: 'Functional & Operational Requirements',
            value: this.proposalForm.get('functionalRequirements')?.value,
          },
          {
            key: 'Contemporary Solutions (National/International)',
            value: this.proposalForm.get('contemporarySolutions')?.value,
          },
          {
            key: 'Miscellaneous Information',
            value: this.proposalForm.get('miscellaneousInfo')?.value,
          },
          {
            key: 'References',
            value: this.proposalForm.get('references')?.value,
          },
          { key: 'Keywords', value: this.proposalForm.get('keywords')?.value },
          {
            key: 'Estimated Navy Requirement (3-5 yrs)',
            value: this.proposalForm.get('estimatedRequirement')?.value,
          },
          {
            key: 'Testing Methodology, Criteria, Venue',
            value: this.proposalForm.get('testingMethodology')?.value,
          },
          {
            key: 'Likely Civil Spin Offs',
            value: this.proposalForm.get('civilSpinOffs')?.value,
          },
          {
            key: 'Technology Readiness Level (TRL)',
            value: this.proposalForm.get('technologyReadinessLevel')?.value,
          },
          {
            key: 'Proposal Category (Substitution/Upgrade/etc.)',
            value: this.proposalForm.get('proposalExplanation')?.value,
          },
          { key: 'QA Agency', value: this.proposalForm.get('qaAgency')?.value },
          {
            key: 'Concurrence by APSO',
            value: this.proposalForm.get('apsoConcurrence')?.value,
          },
          {
            key: 'PQSR',
            value: this.proposalForm.get('pqsr')?.value,
          },
          {
            key: 'Additional Information',
            value: this.proposalForm.get('additionalInformation')?.value,
          },
          {
            key: 'Quantity Required',
            value: this.proposalForm.get('quantityRequired')?.value,
          },
        ],
      };
    } else {
      payload = {
        url: '/revenue/need/version-control/',
        data: [
          { key: 'Proposal Name', value: this.payload.proposal_name },
          {
            key: 'Organisation',
            value: this.challengeForm.get('organisation')?.value,
          },
          { key: 'Category', value: this.challengeForm.get('category')?.value },
          {
            key: 'Release Date',
            value: this.challengeForm.get('releaseDate')?.value,
          },
          {
            key: 'Approved By',
            value: this.challengeForm.get('approvedBy')?.value,
          },
          {
            key: 'Coordinating Agency',
            value: this.challengeForm.get('coordinatingAgency')?.value,
          },
          {
            key: 'Technology Domain',
            value: this.challengeForm.get('technologyDomain')?.value,
          },

          {
            key: 'Challenge Title',
            value: this.challengeForm.get('challengeTitle')?.value,
          },
          {
            key: 'Problem Statement',
            value: this.challengeForm.get('problemStatement')?.value,
          },
          {
            key: 'Challenge Brief/ Definition',
            value: this.challengeForm.get('pdsTitle')?.value,
          },
          {
            key: 'Future Expectation from the prototype development',
            value: this.challengeForm.get('pdsDefinition')?.value,
          },
          {
            key: 'Need/Requirement of the proposed challenge',
            value: this.challengeForm.get('qrs')?.value,
          },
          {
            key: 'IP Value',
            value: this.challengeForm.get('developmentPlatforms')?.value,
          },
          {
            key: 'Functional Advantages',
            value: this.challengeForm.get('targetPlatform')?.value,
          },
          {
            key: 'Domestic Capability Development',
            value: this.challengeForm.get('functions')?.value,
          },
          {
            key: 'Import Substitution (Reliability and Flexibility of existing source of import)',
            value: this.challengeForm.get('testProcedureOutcome')?.value,
          },
          {
            key: 'Preliminary scope of solution being developed)',
            value: this.challengeForm.get('testPlan')?.value,
          },
          {
            key: 'Global competitive nature of the problem including novelty of the solution (from user prospective)',
            value: this.challengeForm.get('endUserTrials')?.value,
          },
          {
            key: 'Potential Market for product/technology (from user perspective)',
            value: this.challengeForm.get('qaStandards')?.value,
          },
          {
            key: 'Risk Assessment',
            value: this.challengeForm.get('testSites')?.value,
          },
          {
            key: 'Pilot Procurement Plan with Minimum Pilot Order Quantity(MPQ)',
            value: this.challengeForm.get('waiverClauses')?.value,
          },
        ],
      };
    }
    this.generatePDFEmitter.emit(payload);
  }
  getChallenge() {
    const isTDFScheme = this.schemeType === 'tdf';

    const url = isTDFScheme
      ? `/tdf/need-generation/?proposal_step__proposal=${this.payload.proposal_id}`
      : `/idex/sqr-details/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`;
    const sub = this.api.getAPI(url).subscribe((resp: any) => {
      this.needGenData = resp[0];
      if (this.schemeType == 'tdf') {
        this.proposalForm.patchValue({
          technologyInsertion: resp[0]?.title,
          justificationText: resp[0]?.major_description,
          exportPotential: resp[0]?.technology_area,
          objective: resp[0]?.objective,
          existingSystem: resp[0]?.description,
          functionalRequirements: resp[0]?.functional_requirement,
          contemporarySolutions: resp[0]?.contemporary_solution,
          miscellaneousInfo: resp[0]?.miscellaneous_information,
          references: resp[0]?.references,
          keywords: resp[0]?.keywords,
          estimatedRequirement: resp[0]?.estimated_requirement,
          testingMethodology: resp[0]?.testing_methodology,
          civilSpinOffs: resp[0]?.civil_spin,
          technologyReadinessLevel: resp[0]?.technology_readiness,
          proposalExplanation: resp[0]?.proposal_explain,
          qaAgency: resp[0]?.qa_agency,
          apsoConcurrence: resp[0]?.concurrence,
          pqsr: resp[0]?.pqsr,
          additionalInformation: resp[0]?.additional_info,
          quantityRequired: resp[0]?.quantity_required,
        });
      } else {
        let res = resp.challenge[0];
        this.challengeForm.patchValue({
          organisation: res.organisation,
          category: res.category,
          releaseDate: res.release_date,
          approvedBy: res.approved_by,
          coordinatingAgency: res.coordinated_agency,
          technologyDomain: res.technology_domain,

          challengeTitle: res.title,
          problemStatement: res.challenge_statement,
          pdsTitle: res.detail_qualitative,
          pdsDefinition: res.definition,
          qrs: res.platform_description,
          developmentPlatforms: res.development_platform,
          targetPlatform: res.technical_operation,
          functions: res.functions,
          testProcedureOutcome: res.test_procedures,
          testPlan: res.integrated,
          endUserTrials: res.user_trials,
          qaStandards: res.applicable_qa,
          testSites: res.offered_test,
          waiverClauses: res.waiver_clauses,
        });
        this.challengeID = res?.id;
        this.PDSGenId = resp.sqr_data[0]?.id;
      }
    });
    this.subscriptions.add(sub);
  }

  onSubmit(): void {
    let payload = {
      proposal_step: this.id,
      challenge: this.challengeID,
      receive_status: 'Received',
      send_to: this.selectedItem.id,
      challenge_data: {
        id: this.challengeID,
        title: this.challengeForm.get('challengeTitle')?.value,
        nodal_officer: this.challengeForm.get('nodalOfficer').value,
        challenge_statement: this.challengeForm.get('pdsTitle').value,
        detail_qualitative: this.challengeForm.get('qrs').value,
        definition: this.challengeForm.get('pdsDefinition').value,
        development_platform: this.challengeForm.get('developmentPlatforms')
          .value,
        platform_description: this.challengeForm.get('targetPlatform').value,
        functions: this.challengeForm.get('functions').value,
        technical_operation: this.challengeForm.get('sop').value,
        test_procedures: this.challengeForm.get('testProcedureOutcome').value,
        integrated: this.challengeForm.get('testPlan').value,
        user_trials: this.challengeForm.get('endUserTrials').value,
        applicable_qa: this.challengeForm.get('qaStandards').value,
        offered_test: this.challengeForm.get('testSites').value,
        waiver_clauses: this.challengeForm.get('waiverClauses').value,
        guidelines: this.challengeForm.get('makeInIndia').value,
        minimum_qty: this.challengeForm.get('minimumOrderQuantity').value,
      },
    };
    if (this.PDSGenId) {
      const sub = this.api
        .putAPI(`/idex/sqr-details/${this.PDSGenId}/`, payload)
        .subscribe((res: any) => {
          if (res) {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Form submitted sucessfully',
            });
            this.getChallenge();
          }
        });
      this.subscriptions.add(sub);
    } else {
      const sub = this.api
        .postAPI(`/idex/sqr-details/`, payload)
        .subscribe((res: any) => {
          if (res) {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Form submitted sucessfully',
            });
            this.getChallenge();
          }
        });
      this.subscriptions.add(sub);
    }
  }

  getFileName(url: string): string {
    return url.split('/').pop() || 'Unknown File';
  }
}
